const evidence = {
  /**
   * 获得证据列表
   * @param {string} id
   */
  getEvidences (id) {
    return this.indexes[id].answer.evidences
  },

  /**
   * 添加证据
   * @param {string} id
   * @param {object|string} data
   * @param {string|number} index
   */
  addEvidence (id, data) {
    let source = this.getEvidences(id)
    this.addFile(source, data)
  },

  /**
   * 删除证据
   * @param {string} id
   * @param {string|number} index
   */
  deleteEvidence (id, index) {
    let source = this.getEvidences(id)
    this.deleteFile(source, index)
  },

  /**
   * 改变证据顺序
   * @param {string} id
   * @param {string|number} index
   * @param {string|number} newIndex
   */
  changeEvidenceIndex (id, index, newIndex) {
    let source = this.getEvidences(id)
    this.changeFileIndex(source, index, newIndex)
  },

  /**
   * 获得照片总数
   * @returns {number}
   */
  getAnswerPhotoCount () {
    let count = 0
    let answers = this.answers
    if (answers) {
      answers.forEach((answer) => {
        if (answer.evidences) {
          answer.evidences.forEach(({type}) => {
            // TODO: 确认下二维码照片数量是否也纳入 普通照片数量
            if (type === 'photo') {
              count++
            }
          })
        }
      })
    }
    return count
  },

  needEvidence (id) {
    let indexe = this.indexes[id]
    let question = indexe.data
    let answer = indexe.answer
    // 仅单选题的证据根据选项判定
    if (question.type === 'select') {
      // 已选择答案时
      if (answer.selectedOptionId[0]) {
        return this.indexes[question.id + answer.selectedOptionId[0]].data.needEvidence
      } else {
        // 未选择答案则默认需要证据
        return true
      }
    } else {
      return question.needEvidence
    }
  }
}

export default evidence



// WEBPACK FOOTER //
// ./src/views/question-review/review/evidence.js